import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  Labeled,
  ShowProps,
  TextField,
  UrlField,
} from "react-admin";
import { Chip, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import OwnershipField from "components/OwnershipField";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Employment Details</Typography>
        </Grid>

        <OwnershipField />

        <Grid item xs={12}>
          <Typography variant="h6">Driver Detail</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Name">
            <TextField source="fullName" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <Labeled source="Nric/Fin">
            <TextField source="nric" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <Labeled source="Date of Birth">
            <CustomDateField source="dateOfBirth" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Gender">
            <TextField source="gender" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Race">
            <TextField source="race" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Nationality">
            <TextField source="nationality" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <FunctionField
            render={(record: any) => (
              <Labeled source="backgroundCheck">
                {record.backgroundChecks &&
                record.backgroundChecks.length > 0 ? (
                  <div>
                    {record.backgroundChecks.map(
                      (backgroundCheck: IBackgroundCheck, index: number) => (
                        <span key={backgroundCheck.id}>
                          <Chip label={backgroundCheck.name} />
                          {index < record.backgroundChecks.length - 1 && " "}
                        </span>
                      )
                    )}
                  </div>
                ) : (
                  <Typography>-</Typography>
                )}
              </Labeled>
            )}
          />
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Contact Details</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Contact">
            <TextField source="contactNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Email">
            <TextField source="email" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={6}>
          <Labeled source="Address">
            <TextField source="address" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Block/No.">
            <TextField source="blockNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Postal Code">
            <TextField source="postalCode" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Document Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="drivingLicenseClass" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
